import { BaseMapper } from '@ps/utils';
import { SelectableQualificationDatum } from '@ps/survey-utils';

import { LocationConditionDto } from '../dtos/location-condition.dto';

export class LocationConditionMapper extends BaseMapper<
  LocationConditionDto,
  SelectableQualificationDatum
> {
  public fromDto(dto: LocationConditionDto): SelectableQualificationDatum {
    return {
      id: Number(dto.id),
      text: dto.name,
    };
  }
}
